import axios from 'axios';
import { API_BASE_URL } from '../config'; // Your existing config file

// 1. Create a new instance of Axios with a base URL
const api = axios.create({
    baseURL: API_BASE_URL
});

// 2. Create an Interceptor to automatically add the token to headers
// This function will run BEFORE every single request is sent.
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');
        
        // If the token exists, add it to the Authorization header
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        return config; // Continue with the request
    }, 
    (error) => {
        // Handle request errors
        return Promise.reject(error);
    }
);

export default api;